// POST /auth/request, the one call the three S1 auth frames this agent owns
// need. Same API_BASE convention as `dashboard/api.ts`: relative "/api" in
// deployed builds (Caddy same-origin), absolute localhost in dev.
//
// The endpoint always answers 202 whether or not the address is known
// (backend/api/routes/auth.py — anti-enumeration is deliberate). A screen
// must therefore navigate on any 2xx and never branch on the response body.

const API_BASE =
  (import.meta.env?.VITE_API_BASE as string | undefined) ??
  "http://localhost:8000";

export async function requestMagicLink(email: string): Promise<void> {
  const res = await fetch(`${API_BASE}/auth/request`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email }),
  });
  if (!res.ok) {
    throw new Error(`The server answered ${res.status}.`);
  }
}

// Deliberately loose (matches @, one dot after it) — a false negative here
// blocks a real address from ever reaching /auth/request, which always
// answers 202 anyway. This exists to catch typos, not to validate RFC 5322.
const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function isValidEmail(value: string): boolean {
  return EMAIL_PATTERN.test(value.trim());
}
